/**
 * Created by RaoMeng on 2018/11/6
 * Desc: 上传图片
 */

import React, {Component} from 'react'
import 'css/new-album.css'
import {Button,} from 'antd'
import {Toast} from 'antd-mobile'
import UploadEnclosure from 'components/UploadEnclosure'
import {_baseURL, API} from "../../configs/api.config";
import {fetchGet, fetchPost} from "../../utils/fetchRequest";
import PictureBean from "../../model/PictureBean";
import {getStrValue} from "../../utils/common";
import './UploadImage.css';

export default class UploadImage extends Component {

    componentWillMount() {
        this.albumId = this.props.match.params.albumId
    }

    componentDidMount() {
        document.title = '编辑相册'
        Toast.loading('', 0)
        this.getPictureList(this.albumId)
    }

    constructor() {
        super()
        this.state = {
            classText: '',
            albumText: '',

            previewVisible: false,
            previewImage: '',
            fileList: [],
            albumTitle:'',
            albumRemarks:""
        }
    }

    render() {
        const {fileList} = this.state;

        return (
            <div className='pageLayout' onChange={this.handelValueCom}>
                <div className='gray-line'></div>
                <div style={{flex: '1'}}>
                    <UploadEnclosure
                        action={API.UPLOAD_FILE}
                        fileList={fileList}
                        limit={false}
                        multiple={true}
                        title='编辑相册'
                        beforeUpload={this.handleBefore.bind(this)}
                        handleChange={this.handleChange.bind(this)}
                        handleRemove={this.handleRemove.bind(this)}
                    />
                </div>
                <div className="item_sty">
                    <div className="left_title1">标题:</div>
                    <input ref='albumTitle'  className="right_input" style={{marginLeft:10}} type="text" placeholder="请输入" maxLength={20} value={this.state.albumTitle}/>
                </div>
                <div className="item_sty">
                    <div className="left_title1">描述:</div>
                    <textarea ref='albumRemarks'  className="form-control textarea_sty" rows="3"  placeholder="请输入" maxLength={100}  value={this.state.albumRemarks}/>
                </div>
                <div className='uploadLayout'>
                    <Button className='commonButton' type="primary" block style={{borderRadius:30}}
                            onClick={this.releaseEvent}>更新</Button>
                </div>
            </div>
        )
    }

    getPictureList = albumId => {
        fetchPost(API.GET_PICTURE_LIST, {
            albumId: albumId,
            pageIndex: 1,
            pageSize: 1000,
        }).then(response => {
            Toast.hide()
            const {fileList} = this.state
            fileList.length = 0

            if (response) {
                const dataArray = response.data.clazzPictureDOS
                if(response.data.albumTitle && response.data.albumRemarks){
                    this.setState({
                        albumTitle:response.data.albumTitle,
                        albumRemarks:response.data.albumRemarks
                    })
                }
                if (dataArray) {
                    dataArray.forEach((picture, index) => {
                        const pictureBean = new PictureBean()

                        pictureBean.picId = getStrValue(picture, 'picId')
                        pictureBean.picName = getStrValue(picture, 'picName')
                        pictureBean.picUrl = getStrValue(picture, 'picUrl')
                        pictureBean.picDate = getStrValue(picture, 'picDate')
                        pictureBean.picType = getStrValue(picture, 'picType')
                        pictureBean.picStatus = getStrValue(picture, 'picStatus')
                        pictureBean.picRemarks = getStrValue(picture, 'picRemarks')
                        pictureBean.schId = getStrValue(picture, 'clazzId')

                        // pictureBean.parentId = getStrValue(picture, 'parentId')
                        // pictureBean.quantity = getStrValue(picture, 'quantity')
                        // pictureBean.schName = getStrValue(picture, 'schName')

                        pictureBean.uid = getStrValue(picture, 'picId')
                        pictureBean.url = getStrValue(picture, 'picUrl')
                        // pictureBean.type = ''
                        pictureBean.thumbUrl = getStrValue(picture, 'picUrl')
                        pictureBean.status = 'done'
                        // pictureBean.size = ''

                        fileList.push(pictureBean)
                    })
                }
            }

            console.log(fileList)
            this.setState({fileList})
        }).catch(error => {
            Toast.hide()
            if (typeof error === 'string') {
                Toast.fail(error)
            }
        })
    }

    handleBefore = (file, fileList) => {

    }
    handelValueCom = (event)=>{
        //获取用户名的值
        let albumTitle = this.refs.albumTitle.value;
        let albumRemarks = this.refs.albumRemarks.value;
        //获得内容的值
        this.setState({
            albumTitle:albumTitle,
            albumRemarks:albumRemarks
        })
    }
    handleRemove = (file) => {
        console.log(file)
        /*fetchPost(API.DELETE_FILE, {
            fileUrls: [file.picUrl]
        }).then(response => {

        }).catch(error => {

        })*/
        return true
    }

    handleChange = fileList => {
        if (fileList) {
            this.setState({fileList})
        }
    }

    releaseEvent = () => {
        Toast.loading('相册更新中...', 0)

        const {fileList} = this.state
        const fileUrls = []
        if (fileList) {
            fileList.forEach((value, index) => {
                fileUrls.push(value.picUrl)
            })
        }
        console.log(fileUrls)

        let albumTitle = this.state.albumTitle
        let albumRemarks = this.state.albumRemarks
        if(albumTitle == '' || albumTitle.length == 0){
            Toast.fail('请输入相册标题')
            return
        }
        if(albumRemarks == '' || albumRemarks.length == 0){
            Toast.fail('请输入相册描述')
            return
        }

        fetchPost(API.UPDATE_ALBUM, {
            pictureUrls: JSON.stringify(fileUrls),
            albumId: this.albumId,
            albumTitle:albumTitle,
            albumRemarks:albumRemarks
        }).then(response => {
            Toast.hide()
            Toast.success('更新成功')
        }).catch(error => {
            Toast.hide()
            Toast.fail(error)
        })
    }

}